<script lang="ts">
	import { setActiveElement } from '$lib/client/store';
	import { onMount } from 'svelte';

	onMount(async () => {
		document.addEventListener('focusin', setActiveElement);
		document.addEventListener('focusout', setActiveElement);

		// Add some error handling for fetches
		const originalFetch: typeof fetch = window.fetch;
		//@ts-expect-error - Wrap the built-in browser fetch function
		window.fetch = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
			const url = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;

			const is_api_call: boolean = /api.*\.kingtechnology\.com/.test(url);
			if (is_api_call) {
				if (url.includes('address')) {
					try {
						const response: Response = await originalFetch(input, init);
						return response;
					} catch (error: any) {
						alert(`Unable to connect to server. Please try again later.`);
						console.error(error);
						return error;
					}
				}
			} else {
				return originalFetch(input, init);
			}
		};
	});
</script>

<slot />
